import apiFetch from '../apiFetch'

export default function ({idPool,formatoFechaHora}) {
  return apiFetch({
    endPoint: `Pool/imprimirMiniEtiqueta?idPool=${idPool}&formatoFechaHora=${formatoFechaHora}`,
    method: 'GET', body: null, token: null
  })
}